var _g, _path, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#3B4395",
    strokeWidth: 0.25,
    d: "M5.64,14.09c-0.04,0-0.08-0.03-0.08-0.07l-0.2-1.79c-0.01-0.04,0.03-0.08,0.07-0.09 c0.04,0,0.08,0.03,0.09,0.07L5.72,14C5.73,14.05,5.7,14.09,5.64,14.09C5.65,14.09,5.65,14.09,5.64,14.09z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--app-icons-color)",
    stroke: "var(--app-icons-color)",
    d: "M1.48,22.89H22.8V1.57L1.48,22.89z M18.81,18.93h-7.93L18.81,11V18.93z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.49,
    y: 9.6,
    transform: "matrix(0.7069 -0.7073 0.7073 0.7069 -5.1208 8.8758)",
    fill: "#FF933C",
    stroke: "#FF933C",
    strokeWidth: 0.25,
    strokeLinejoin: "round",
    width: 15.31,
    height: 2.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.4,
    y: 3.81,
    transform: "matrix(0.7073 -0.7069 0.7069 0.7073 0.6707 11.2673)",
    fill: "var(--app-icons-color)",
    stroke: "var(--app-icons-color)",
    strokeWidth: 0.25,
    strokeLinejoin: "round",
    width: 1.07,
    height: 2.03
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.25,
    strokeLinejoin: "round",
    d: "M15.04,5.16l0.41-0.41c0.4-0.4,0.4-1.04,0-1.43c-0.4-0.4-1.04-0.4-1.43,0L13.6,3.73L15.04,5.16z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "var(--app-icons-color)",
    stroke: "var(--app-icons-color)",
    strokeWidth: 0.25,
    strokeLinejoin: "round",
    points: "2.02,15.31 3.45,16.75 1.02,17.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "var(--app-icons-color)",
    stroke: "var(--app-icons-color)",
    strokeWidth: 0.25,
    strokeLinejoin: "round",
    points: "1.51,16.54 1.02,17.74 2.22,17.25  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.f9432e06.svg";
export { ForwardRef as ReactComponent };